import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  // Load translations from /public/locales
  .use(Backend)
  // Detect user language (but will be overridden by lng setting)
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    fallbackLng: 'es', // Fallback to Spanish if detected language is not available
    supportedLngs: ['es', 'en'],
    debug: process.env.NODE_ENV === 'dev',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Backend configuration
    backend: {
      // Path to load language files
      loadPath: '/i18n/{{lng}}.json',
    },

    // Detection options - respects user's saved preference
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    react: {
      useSuspense: true,
    },
  });

export default i18n;
